import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import {
  POSModifierPromptAssignment,
  POSModifierPromptAssignmentEditDto
} from 'src/app/models/pos-manager.model';
import { ApiType } from 'src/app/pos.config';
import { ErrorService } from 'src/app/services/error/error.service';
import { AppStateHelper } from 'src/app/store/app/app.state.helper';
import { APP_STATE_TOKEN } from 'src/app/store/app/app.state.model';

@Injectable({ providedIn: 'root' })
export class PosModifierPromptAssignmentService {
  constructor(
    private http: HttpClient,
    private store: Store,
    private readonly errorService: ErrorService
  ) {}
  private getBaseUrl() {
    const baseUrl = this.store.selectSnapshot(APP_STATE_TOKEN).apiBaseUrl;
    const posManagerApiUrl = AppStateHelper.getPosManagerApiUrl(baseUrl);

    return `${posManagerApiUrl}modifier_prompt_assignments`;
  }

  createAssignment(
    assignment: Partial<POSModifierPromptAssignmentEditDto>
  ): Observable<POSModifierPromptAssignment> {
    return this.http
      .post<POSModifierPromptAssignment>(`${this.getBaseUrl()}`, assignment)
      .pipe(
        this.errorService.retryPipe(ApiType.Mutate),
        map((response) => response)
      );
  }

  updateAssignment(
    id: number,
    assignment: Partial<POSModifierPromptAssignmentEditDto>
  ): Observable<POSModifierPromptAssignment> {
    return this.http
      .put<POSModifierPromptAssignment>(
        `${this.getBaseUrl()}/${id}`,
        assignment
      )
      .pipe(
        this.errorService.retryPipe(ApiType.Mutate),
        map((response) => response)
      );
  }

  deleteAssignment(id: number): Observable<boolean> {
    return this.http
      .delete<{ success: boolean }>(`${this.getBaseUrl()}/${id}`)
      .pipe(
        this.errorService.retryPipe(ApiType.Mutate),
        map((response) => response.success)
      );
  }
}
